import React from "react"
import Input from "@infotech/uikit-input"
import styles from "./styles.css"

/* Uikit Input wrapper to works with reduxForm Field */
export default ({ input, meta: { valid, error }, ...rest }) => (
  <div className={styles[`input-wrapper`]}>
    <Input
      {...input}
      {...rest}
      invalid={!valid}
      className={`${error ? styles[`red-border`] : ``}`}
    />
    <div className={styles[`input-error`]}>{error}</div>
  </div>
)
